// src/hooks/useFetchUserProfile.ts
import { useState, useEffect } from 'react';
import { UserProfile } from '../interfaces';
import config from '../config';
import { useSession } from '../contexts/SessionContext';

const useFetchUserProfile = () => {
  const [profile, setProfile] = useState<UserProfile | null>(null);
  const [error, setError] = useState<string | null>(null);
  const { sessionState } = useSession();

  useEffect(() => {
    const fetchUserProfile = async () => {
      if (!sessionState.account) {
        setError('Account is missing');
        return;
      }
      if (!sessionState.account?.token) {
        setError('Token is missing');
        return;
      }
      const token = sessionState.account?.token;

      try {
        const response = await fetch(`${config.centralApiBaseUrl}/account`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Access-Control-Allow-Origin': '*',
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch user profile');
        }

        const data = await response.json();
        setProfile(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An unknown error occurred');
      }
    };

    fetchUserProfile();
  }, [sessionState]);

  return { profile, error };
};

export default useFetchUserProfile;
